(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var SPRINKLE_COLORS = ['#FF6B9D', '#FFD93D', '#6BCB77', '#4D96FF', '#FF8C42', '#E8B4F8', '#FFFFFF', '#FDDA76', '#B19CD9'];
  var CHOCO_BASE = ['#2C1810', '#3E2723', '#4E342E', '#5D4037'];
  var CHOCO_HIGHLIGHT = ['#6D4C41', '#8D6E63', '#795548'];
  var PARTICLE_COUNT = 90;
  var TOTAL_DURATION = 3000;
  var FALL_MIN = 2;
  var FALL_MAX = 2.8;
  var CHOCO_CHIP_RATIO = 0.38;

  function sprinkleSvg(variant) {
    if (variant === 'nonpareil') {
      return (
        '<svg viewBox="0 0 8 8" aria-hidden="true" focusable="false">' +
        '<circle cx="4" cy="4" r="3.5" fill="currentColor"/>' +
        '</svg>'
      );
    }
    if (variant === 'jimmie') {
      return (
        '<svg viewBox="0 0 22 5" aria-hidden="true" focusable="false">' +
        '<rect x="0.5" y="0.5" width="21" height="4" rx="2" ry="2" fill="currentColor"/>' +
        '</svg>'
      );
    }
    return (
      '<svg viewBox="0 0 18 8" aria-hidden="true" focusable="false">' +
      '<path d="M1 4 C4 1.5, 14 1.5, 17 4 C14 6.5, 4 6.5, 1 4 Z" fill="currentColor"/>' +
      '</svg>'
    );
  }

  function chocoChipSvg(base, highlight) {
    return (
      '<svg viewBox="0 0 14 17" aria-hidden="true" focusable="false">' +
      '<path fill="' +
      base +
      '" d="M7 0.5 C4.2 0.5 1.8 3.2 1.5 6.8 C1.2 10.2 3.4 13.6 7 15.8 C10.6 13.6 12.8 10.2 12.5 6.8 C12.2 3.2 9.8 0.5 7 0.5 Z"/>' +
      '<path fill="' +
      highlight +
      '" opacity="0.45" d="M4.5 4.2 C5.2 3.4 6.4 3.1 7.2 3.8 C6.5 5.2 5.4 6.1 4.2 5.8 C3.8 5.1 4 4.6 4.5 4.2 Z"/>' +
      '<path fill="#1a0f0a" opacity="0.2" d="M9 11.5 C9.8 12.2 10.8 12.4 11.2 11.8 C10.5 11 9.2 10.8 9 11.5 Z"/>' +
      '</svg>'
    );
  }

  function createPiece(container) {
    var piece = document.createElement('span');
    var isChocoChip = Math.random() < CHOCO_CHIP_RATIO;

    var left = Math.random() * 100;
    var delay = Math.random() * 0.5;
    var duration = FALL_MIN + Math.random() * (FALL_MAX - FALL_MIN);
    var drift = -40 + Math.random() * 80;
    var rotation = Math.random() * 720;

    if (isChocoChip) {
      piece.className = 'celebration-confetti__piece celebration-confetti__piece--choco-chip';
      var chipW = 8 + Math.random() * 8;
      var chipH = chipW * (1.05 + Math.random() * 0.25);
      piece.style.width = chipW + 'px';
      piece.style.height = chipH + 'px';
      var base = CHOCO_BASE[Math.floor(Math.random() * CHOCO_BASE.length)];
      var highlight = CHOCO_HIGHLIGHT[Math.floor(Math.random() * CHOCO_HIGHLIGHT.length)];
      piece.innerHTML = chocoChipSvg(base, highlight);
    } else {
      piece.className = 'celebration-confetti__piece celebration-confetti__piece--sprinkle';
      var roll = Math.random();
      var variant = roll < 0.55 ? 'jimmie' : roll < 0.85 ? 'curved' : 'nonpareil';
      var color = SPRINKLE_COLORS[Math.floor(Math.random() * SPRINKLE_COLORS.length)];

      if (variant === 'nonpareil') {
        var dot = 5 + Math.random() * 4;
        piece.style.width = dot + 'px';
        piece.style.height = dot + 'px';
      } else if (variant === 'jimmie') {
        var len = 12 + Math.random() * 10;
        piece.style.width = len + 'px';
        piece.style.height = len * 0.22 + 'px';
      } else {
        var curvedW = 11 + Math.random() * 9;
        piece.style.width = curvedW + 'px';
        piece.style.height = curvedW * 0.42 + 'px';
      }

      piece.style.color = color;
      piece.innerHTML = sprinkleSvg(variant);
      rotation += Math.random() * 180;
    }

    piece.style.left = left + '%';
    piece.style.setProperty('--drift', drift + 'px');
    piece.style.setProperty('--rotation', rotation + 'deg');
    piece.style.animationDuration = duration + 's';
    piece.style.animationDelay = delay + 's';

    container.appendChild(piece);
    return piece;
  }

  function startCelebration() {
    var container = document.createElement('div');
    container.className = 'celebration-confetti';
    container.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < PARTICLE_COUNT; i++) {
      createPiece(container);
    }

    document.body.appendChild(container);

    window.setTimeout(function () {
      container.remove();
    }, TOTAL_DURATION);
  }

  if (document.readyState === 'complete') {
    startCelebration();
  } else {
    window.addEventListener('load', startCelebration, { once: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      startCelebration();
    }
  });
})();
